import {SETTINGS_VEHICLE_CONDITIONS} from '../constants/TEST_DRIVE_CALENDAR';
import {getVehicleConditionLabel} from './getVehicleConditionLabel';

export const getVehicleConditionOptions = () =>
  SETTINGS_VEHICLE_CONDITIONS.map((condition) => ({
    value: condition,
    label: getVehicleConditionLabel(condition),
  }));
